module.exports = __webpack_public_path__ + "img/icon_customer_service_grey.51eeedeb.svg";